var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "row h-100 d-flex flex-column flex-nowrap" },
    [
      _c(
        "b-modal",
        {
          staticClass: "mt-3",
          attrs: {
            size: "lg",
            title: _setup.paymentMethod ? "Update Billing" : "Add Billing",
            "modal-class": "vue-need-bootstrap",
            lazy: "",
            centered: "",
            "hide-footer": "",
            "no-close-on-backdrop": "",
          },
          model: {
            value: _setup.showUpdateCardDialog,
            callback: function ($$v) {
              _setup.showUpdateCardDialog = $$v
            },
            expression: "showUpdateCardDialog",
          },
        },
        [
          _c(_setup.CreditCardInput, {
            attrs: {
              "stripe-public-key": _setup.stripePublicKey,
              store: _setup.storeUrl,
              "from-pod-billing": "",
              "new-card": _setup.paymentMethod == null,
            },
            on: { "card-updated": _setup.onCardSubmit },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mt-3" }, [
        _c("div", { staticClass: "card white-card shadow-sm" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h4", { staticClass: "card-title mb-3" }, [
              _vm._v("POD Billing Details"),
            ]),
            _vm._v(" "),
            _c("div", { class: { busy: _setup.loadingPaymentMethod } }, [
              _setup.loadingPaymentMethod
                ? _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c("b-spinner", {
                        staticClass: "my-2",
                        attrs: { variant: "primary" },
                      }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass: "row small-card-content",
                      class: { "has-card": _setup.paymentMethod },
                    },
                    [
                      _c("div", { staticClass: "col-10 row" }, [
                        !_setup.paymentMethod &&
                        !_setup.errorGettingPaymentMethod
                          ? _c(
                              "div",
                              {
                                staticClass: "col-10 align-items-center d-flex",
                              },
                              [
                                _vm._v(
                                  "\n                                Please enter your credit card details so we can pay the POD every time you sell\n                                their products.\n                            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _setup.errorGettingPaymentMethod
                          ? _c(
                              "div",
                              {
                                staticClass: "col-10 align-items-center d-flex",
                              },
                              [
                                _vm._v(
                                  "\n                                There was an error getting the credit card information.\n                            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6" }, [
                          _setup.paymentMethod
                            ? _c(
                                "div",
                                { staticClass: "align-items-center d-flex" },
                                [
                                  _c(_setup.CardIcon, {
                                    staticClass: "d-inline",
                                    attrs: { card: _setup.paymentMethod.Brand },
                                  }),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("h5", { staticClass: "d-inline ml-2" }, [
                                      _vm._v(
                                        "Card ending in " +
                                          _vm._s(_setup.paymentMethod.Last4)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "small",
                                      {
                                        staticClass:
                                          "card-expiration card-expiration ml-1",
                                      },
                                      [
                                        _vm._v(
                                          "exp. " +
                                            _vm._s(
                                              _setup.paymentMethod.ExpMonth.toString().padStart(
                                                2,
                                                "0"
                                              )
                                            ) +
                                            "/" +
                                            _vm._s(_setup.paymentMethod.ExpYear)
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _setup.customer && _setup.customer.Email
                            ? _c("div", { staticClass: "mt-3" }, [
                                _vm._v(
                                  "\n                                    Billing contact:\n                                    "
                                ),
                                _c("strong", [
                                  _vm._v(_vm._s(_setup.customer.Email)),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _setup.paymentMethod
                          ? _c("div", { staticClass: "col-6" }, [
                              _c("ul", [
                                _setup.paymentMethod.BillingDetails.Name
                                  ? _c("li", [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _setup.paymentMethod.BillingDetails
                                              .Name
                                          ) +
                                          "\n                                    "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _setup.paymentMethod.BillingDetails.Address1
                                  ? _c("li", [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _setup.paymentMethod.BillingDetails
                                              .Address1
                                          ) +
                                          "\n                                    "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _setup.paymentMethod.BillingDetails.Country &&
                                _setup.paymentMethod.BillingDetails.City
                                  ? _c("li", [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _setup.paymentMethod.BillingDetails
                                              .City
                                          ) +
                                          ",\n                                        " +
                                          _vm._s(
                                            _setup.paymentMethod.BillingDetails
                                              .Country
                                          )
                                      ),
                                      _setup.paymentMethod.BillingDetails.State
                                        ? _c("span", [
                                            _vm._v(
                                              ", " +
                                                _vm._s(
                                                  _setup.paymentMethod
                                                    .BillingDetails.State
                                                )
                                            ),
                                          ])
                                        : _vm._e(),
                                      _setup.paymentMethod.BillingDetails
                                        .PostalCode
                                        ? _c("span", [
                                            _vm._v(
                                              ", " +
                                                _vm._s(
                                                  _setup.paymentMethod
                                                    .BillingDetails.PostalCode
                                                )
                                            ),
                                          ])
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _setup.paymentMethod && !_setup.errorGettingPaymentMethod
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col d-flex align-items-end justify-content-end",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  on: {
                                    click: function ($event) {
                                      return _setup.editCreditCard()
                                    },
                                  },
                                },
                                [_vm._v("Edit billing")]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_setup.paymentMethod && !_setup.errorGettingPaymentMethod
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col d-flex align-items-end justify-content-end",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  on: {
                                    click: function ($event) {
                                      return _setup.editCreditCard()
                                    },
                                  },
                                },
                                [_vm._v("Add Credit Card")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-3 invoice-card" }, [
        _c("div", { staticClass: "card white-card shadow-sm h-100" }, [
          _setup.loadingInvoices
            ? _c("div", { staticClass: "card-body d-flex flex-column" }, [
                _c("h4", { staticClass: "card-title mb-3" }, [
                  _vm._v("POD Billing History"),
                ]),
                _vm._v(" "),
                _setup.loadingPaymentMethod
                  ? _c(
                      "div",
                      { staticClass: "text-center" },
                      [
                        _c("b-spinner", {
                          staticClass: "my-2",
                          attrs: { variant: "primary" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_setup.loadingInvoices
            ? _c(
                "div",
                { staticClass: "card-body d-flex flex-column" },
                [
                  _c("h4", { staticClass: "card-title mb-3" }, [
                    _vm._v("POD Billing History"),
                  ]),
                  _vm._v(" "),
                  !_setup.paymentMethod && !_setup.errorGettingInvoices
                    ? _c(
                        "div",
                        { staticClass: "bg-light text-dark p-3 rounded" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "my-auto mr-2",
                            attrs: { icon: ["fa-solid", "fa-circle-info"] },
                          }),
                          _vm._v(
                            "\n                    Your POD billing history will appear here once transactions are made. Get started by entering\n                    your payment details to activate POD billing.\n                "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _setup.paymentMethod &&
                  !_setup.errorGettingInvoices &&
                  _setup.invoiceItems &&
                  _setup.invoiceItems.length == 0
                    ? _c(
                        "div",
                        { staticClass: "bg-light text-dark p-3 rounded" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "my-auto mr-2",
                            attrs: { icon: ["fa-solid", "fa-circle-info"] },
                          }),
                          _vm._v(
                            "\n                    Your POD billing history will appear here once transactions are made.\n                "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _setup.errorGettingInvoices
                    ? _c(
                        "div",
                        { staticClass: "bg-light text-dark p-3 rounded" },
                        [
                          _vm._v(
                            "\n                    There was an error getting the invoices.\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _setup.paymentMethod &&
                  !_setup.errorGettingInvoices &&
                  _setup.invoiceItems &&
                  _setup.invoiceItems.length > 0
                    ? _c("b-table", {
                        staticClass: "invoice-table flex-grow-1",
                        attrs: {
                          "sticky-header": "",
                          hover: "",
                          fixed: "",
                          "show-empty": "",
                          fields: _setup.invoiceTableFields,
                          items: _setup.invoiceItems,
                          busy: _setup.loadingInvoices,
                          "empty-text": "No invoices",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "empty",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "text-center mt-3" },
                                    [
                                      _c("h3", [
                                        _vm._v(_vm._s(scope.emptyText)),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "table-busy",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "align-items-center d-flex justify-content-center w-100 mt-3",
                                    },
                                    [
                                      _c("b-spinner", {
                                        staticClass: "my-2",
                                        attrs: { variant: "primary" },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "cell(date)",
                              fn: function (data) {
                                return [_c("div", [_vm._v(_vm._s(data.value))])]
                              },
                            },
                            {
                              key: "cell(description)",
                              fn: function () {
                                return [
                                  _c("div", [_vm._v("Customily Service")]),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "cell(amount)",
                              fn: function (data) {
                                return [_c("div", [_vm._v(_vm._s(data.value))])]
                              },
                            },
                            {
                              key: "cell(status)",
                              fn: function (data) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-capitalize",
                                      class: {
                                        paid: data.value === "paid",
                                        "primary-text": data.value === "paid",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(data.value) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(invoice)",
                              fn: function (data) {
                                return [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: data.value,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-eye invoice-icon",
                                      }),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2563933375
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _setup.paymentMethod &&
                  !_setup.errorGettingInvoices &&
                  _setup.invoiceItems &&
                  _setup.invoiceItems.length > 0
                    ? _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c("div", { staticClass: "btn-group" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-secondary btn-white shadow-none",
                                class: {
                                  disabled:
                                    _setup.loadingInvoices ||
                                    _setup.disablePrevBtn,
                                },
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _setup.goPrevInvoicesPage()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            ‹\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-secondary btn-white shadow-none",
                                class: {
                                  disabled:
                                    _setup.loadingInvoices ||
                                    _setup.disableNextBtn,
                                },
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _setup.goNextInvoicesPage()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            ›\n                        "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }